module.exports = __webpack_public_path__ + "static/media/tableappmainsmall.5b284798.png";